module.exports = __webpack_public_path__ + "img/logo-genamet.3abb635b.png";